import React, { Component } from "react";
import { legacy_connect as connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActionCreator } from "actions";
import { CommonModalHeader } from "component/common";
import * as queryString from "query-string";
import "containers/GameRoundResult/styles.scss";
import { withTranslation } from "react-i18next";

class GameRoundResult extends Component {
  constructor(props) {
    super(props);
    this.modalRef = React.createRef();
    this.iframeRef = React.createRef();
    this.onClickPrevious = this._onClickPrevious.bind(this);
    this.onCloseClickHandler = this._onCloseClickHandler.bind(this);
  }

  _onClickPrevious() {
    if (this.props.isModal && this.props.onClickPreviousModal) {
      this.props.onClickPreviousModal();
    } else {
      this.props.history.goBack();
    }
  }

  _onCloseClickHandler() {
    if (this.props.isModal) {
      this.closeModal();
    } else {
      this.props.navigateTo(this.props.location.pathname);
    }
  }

  closeModal() {
    if (this.modalRef.current) {
      this.modalRef.current.classList.remove("open");
      this.modalRef.current.classList.add("closing");

      const parentModal = document.querySelector(
        ".round-history-per-game.modal-mode",
      );
      if (parentModal) {
        parentModal.style.overflow = "auto";
      }
      this.props.onCloseModal && this.props.onCloseModal();
    } else {
      this.props.onCloseModal && this.props.onCloseModal();
    }
  }

  componentDidMount() {
    if (this.props.isModal) {
      document.body.style.overflow = "hidden";

      setTimeout(() => {
        if (this.modalRef.current) {
          this.modalRef.current.classList.add("opening");
          setTimeout(() => {
            this.modalRef.current.classList.remove("opening");
            this.modalRef.current.classList.add("open");
          }, 300);
        }
      }, 10);
    }

    if (this.iframeRef.current) {
      this.iframeRef.current.onload = () => {
        try {
          const iframeDoc =
            this.iframeRef.current.contentDocument ||
            this.iframeRef.current.contentWindow.document;
          if (iframeDoc && iframeDoc.body) {
            iframeDoc.body.style.overflow = "auto";
            iframeDoc.body.style.height = "100%";
            iframeDoc.body.style.width = "100%";
          }
        } catch (e) {
          console.log(
            "Cannot modify iframe content due to cross-origin restrictions",
          );
        }
      };
    }
  }

  componentWillUnmount() {
    if (this.props.isModal) {
      document.body.style.overflow = "auto";

      const parentModal = document.querySelector(
        ".round-history-per-game.modal-mode",
      );
      if (parentModal) {
        parentModal.style.overflow = "auto";
      }
    }
  }

  render() {
    const { t, isModal, gameResultUrl } = this.props;

    if (!isModal && this.props.modalRel !== "game-round-result") {
      return null;
    }

    if (!gameResultUrl) {
      return null;
    }

    const content = (
      <>
        <CommonModalHeader
          onClickPrevious={this.onClickPrevious}
          onCloseClickHandler={this.onCloseClickHandler}
          showCloseButton={isModal}
        />
        <div className="title row" data-testid="results-title">
          <div className="col">
            <span>{t("result")}</span>
          </div>
        </div>

        <div className="iframe-container">
          <iframe
            ref={this.iframeRef}
            title="Game Round Result"
            src={gameResultUrl}
            className="result-iframe"
            scrolling="yes"
            sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
            allow="fullscreen"
            style={{
              overflow: "auto",
              WebkitOverflowScrolling: "touch",
            }}
          />
        </div>
      </>
    );

    if (isModal) {
      return (
        <div
          ref={this.modalRef}
          className="game-round-result-modal-backdrop"
          onClick={this.onCloseClickHandler}
        >
          <div
            className="game-round-result modal-mode"
            data-testid="results-panel"
            onClick={(e) => e.stopPropagation()}
          >
            {content}
          </div>
        </div>
      );
    }

    return (
      <div className="game-round-result" data-testid="results-panel">
        {content}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const isModal = ownProps.isModal || false;

  if (isModal) {
    return {
      isModal: true,
      gameResultUrl: ownProps.gameResultUrl,
      navigateTo: (path) =>
        ownProps.history ? ownProps.history.push(path) : () => {},
    };
  }

  let { modalRel, gameResultUrl } = queryString.parse(
    (ownProps.location && ownProps.location.search) || window.location.search,
  );

  if (modalRel !== "game-round-result") {
    return {};
  }

  return {
    modalRel,
    gameResultUrl: gameResultUrl ? atob(gameResultUrl) : null,
    navigateTo: (path) =>
      ownProps.history ? ownProps.history.push(path) : () => {},
    isModal: false,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return bindActionCreators(ActionCreator, dispatch);
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, stateProps, ownProps, {});
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(withTranslation("translation")(GameRoundResult));
